<form class="form-horizontal" (submit)="$event.preventDefault(); handleSearchFormSubmit()">
  <p>
    <span class="input-group">
      <input
        type="text"
        class="form-control"
        name="eventToolbarSearchKeyword"
        [(ngModel)]="searchParams.Keyword"
        (ngModelChange)="handleModelChange()"
        autocomplete="off"
        [placeholder]="'events.shared.select-event.search-events-placeholder' | translate | ucfirst"
      />
      <span class="input-group-btn">
        <button pButton type="submit" class="btn btn-default" [icon]="_searching.busy ? '' : 'pi pi-search'" [disabled]="_searching.busy">
          <wl-busy [show]="_searching.busy"></wl-busy>
        </button>
        <button
          pButton
          type="button"
          class="btn btn-default"
          icon="pi pi-times-circle"
          (click)="handleResetClick()"
          [disabled]="_searching.busy"
        ></button>
      </span>
    </span>
  </p>
  <p>
    <span class="wl-give-calendar-right-padding">
      <wl-date-selector name="searchDateBegin" [(ngModel)]="searchParams.SearchDateBegin"></wl-date-selector>
      <wl-date-selector name="searchDateEnd" [(ngModel)]="searchParams.SearchDateEnd"></wl-date-selector>
    </span>
  </p>
  <p>
    <label class="checkbox-inline">
      <input type="checkbox" name="orgEvent" [(ngModel)]="searchParams.OrganizationEvent" />
      {{ 'events.shared.select-event.restrict-to-organization-label' | translate }}
    </label>
    <label class="checkbox-inline">
      <input type="checkbox" name="communityEvent" [(ngModel)]="searchParams.CommunityEvent" />
      {{ 'events.shared.select-event.restrict-to-community-label' | translate }}
    </label>
    <label class="checkbox-inline">
      <input type="checkbox" name="membersOnlyEvent" [(ngModel)]="searchParams.MembersOnlyEvent" />
      {{ 'events.shared.select-event.restrict-to-members-only-label' | translate }}
    </label>
    <label class="checkbox-inline">
      <input type="checkbox" name="internalEvent" [(ngModel)]="searchParams.InternalEvent" />
      {{ 'events.shared.select-event.restrict-to-internal-label' | translate }}
    </label>
  </p>
</form>

<div class="wl-select-event-results form-horizontal">
  <div class="text-danger" *ngIf="!_searching.busy && !_searching.success">
    {{ _searching.message }}
  </div>

  <div *ngIf="_results && !_results?.TotalCount && !_searching.busy && _searching.success">
    {{ 'events.shared.select-event.no-results' | translate | ucfirst }}
  </div>

  <p-dataView
    #eventsResultList
    [lazy]="true"
    [rows]="10"
    [value]="_results?.Result"
    [paginator]="true"
    (onLazyLoad)="lazyLoad($event)"
    [totalRecords]="_results?.TotalCount"
    [hidden]="!_results?.TotalCount"
    layout="list"
  >
    <ng-template let-events pTemplate="listItem" type="item">
      <div class="form-group" *ngFor="let event of events">
        <div class="col-sm-12">
          <div class="pull-right">
            <button pButton type="button" class="btn btn-primary" (click)="handleSelectEventClick(event)">
              <span *ngIf="selectButtonGlyphIcon" class="glyphicon" [ngClass]="'glyphicon-' + selectButtonGlyphIcon"></span>
              {{ selectButtonText || ('common.select' | translate | titlecase) }}
            </button>
          </div>

          {{ event.EventName }} ({{ event.StartDate | date: 'MM/dd/yyyy' }})
        </div>
      </div>
    </ng-template>
  </p-dataView>
</div>
